import { render, staticRenderFns } from "./HelpAndSupport.vue?vue&type=template&id=173bd029&scoped=true&"
import script from "./HelpAndSupport.vue?vue&type=script&lang=js&"
export * from "./HelpAndSupport.vue?vue&type=script&lang=js&"
import style0 from "./HelpAndSupport.vue?vue&type=style&index=0&id=173bd029&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173bd029",
  null
  
)

export default component.exports
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInput});
